import "core-js/modules/es.array.push.js";
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue";
import _imports_0 from '@/assets/images/homeActice.png';
import _imports_1 from '@/assets/images/homeUnActive.png';
import _imports_2 from '@/assets/images/bookActive.png';
import _imports_3 from '@/assets/images/bookUnActive.png';
import _imports_4 from '@/assets/images/center.png';
import _imports_5 from '@/assets/images/viewActive.png';
import _imports_6 from '@/assets/images/viewUnActive.png';
import _imports_7 from '@/assets/images/bookFillActive.png';
import _imports_8 from '@/assets/images/bookFillUnActive.png';
const _hoisted_1 = {
  class: "AppFooterMobile"
};
const _hoisted_2 = {
  key: 0,
  src: _imports_0,
  alt: ""
};
const _hoisted_3 = {
  key: 1,
  src: _imports_1,
  alt: ""
};
const _hoisted_4 = {
  class: "moduleItem"
};
const _hoisted_5 = {
  key: 0,
  src: _imports_2,
  alt: ""
};
const _hoisted_6 = {
  key: 1,
  src: _imports_3,
  alt: ""
};
const _hoisted_7 = {
  class: "moduleItem"
};
const _hoisted_8 = {
  key: 0,
  src: _imports_5,
  alt: ""
};
const _hoisted_9 = {
  key: 1,
  src: _imports_6,
  alt: ""
};
const _hoisted_10 = {
  class: "moduleItem"
};
const _hoisted_11 = {
  key: 0,
  src: _imports_7,
  alt: ""
};
const _hoisted_12 = {
  key: 1,
  src: _imports_8,
  alt: ""
};
import { ref } from "vue";
import { useRouter } from "vue-router";
export default {
  __name: 'AppFooterMobile',
  setup(__props) {
    const router = useRouter();
    let activeItem = ref("首页");

    // 跳转到首页
    const gotoHomePage = () => {
      router.push({
        path: "/homePageMobile"
      });
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "moduleItem",
        onClick: gotoHomePage
      }, [_unref(activeItem) == '首页' ? (_openBlock(), _createElementBlock("img", _hoisted_2)) : _createCommentVNode("", true), _unref(activeItem) != '首页' ? (_openBlock(), _createElementBlock("img", _hoisted_3)) : _createCommentVNode("", true), _cache[0] || (_cache[0] = _createElementVNode("p", null, "首页", -1))]), _createElementVNode("div", _hoisted_4, [_unref(activeItem) == '免费资料' ? (_openBlock(), _createElementBlock("img", _hoisted_5)) : _createCommentVNode("", true), _unref(activeItem) != '免费资料' ? (_openBlock(), _createElementBlock("img", _hoisted_6)) : _createCommentVNode("", true), _cache[1] || (_cache[1] = _createElementVNode("p", null, "免费资料", -1))]), _cache[4] || (_cache[4] = _createElementVNode("div", {
        class: "moduleItem_center"
      }, [_createElementVNode("img", {
        src: _imports_4,
        alt: ""
      }), _createElementVNode("p", null, "个人中心")], -1)), _createElementVNode("div", _hoisted_7, [_unref(activeItem) == '试听' ? (_openBlock(), _createElementBlock("img", _hoisted_8)) : _createCommentVNode("", true), _unref(activeItem) != '试听' ? (_openBlock(), _createElementBlock("img", _hoisted_9)) : _createCommentVNode("", true), _cache[2] || (_cache[2] = _createElementVNode("p", null, "试听", -1))]), _createElementVNode("div", _hoisted_10, [_unref(activeItem) == '选课' ? (_openBlock(), _createElementBlock("img", _hoisted_11)) : _createCommentVNode("", true), _unref(activeItem) != '选课' ? (_openBlock(), _createElementBlock("img", _hoisted_12)) : _createCommentVNode("", true), _cache[3] || (_cache[3] = _createElementVNode("p", null, "选课", -1))])]);
    };
  }
};